export const DEFAULT_EXTENSIONS = ['mjs', 'js', 'jsx', 'json'];
